import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  createTheme,
  ThemeProvider,
} from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import './styles/index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';
import PoppinsRegular from './assets/fonts/Poppins/Poppins-Regular.ttf';
import { Provider } from 'react-redux';
import { store } from './store';

// Capture auth code from URL immediately on page load (before React mounts)
// This ensures we capture it even if React Router hasn't initialized yet
(function captureAuthCode() {
  try {
    const url = window.location.href;
    if (url.includes('code=')) {
      const urlObj = new URL(url);
      const code = urlObj.searchParams.get('code');
      if (code) {
        sessionStorage.setItem('auth_code', code);
      }
    }
  } catch (error) {
    console.warn('Error capturing auth code on page load:', error);
  }
})();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const theme = createTheme({
  typography: {
    fontFamily: 'Poppins',
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'Poppins';
          font-style: normal;
          font-display: swap;
          font-weight: 400;
          src: local('Poppins'), local('Poppins-Regular'), url(${PoppinsRegular}) format('TrueType');
        }
      `,
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'capitalize',
          color: '#808080',
          fontSize: '17px',
          fontWeight: 500,
          '&.Mui-selected': {
            color: '#008fed',
          },
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          background: 'rgba(51, 51, 51, 1)',
          color: 'rgba(255, 255, 255, 1)',
          borderRadius: '24px',
        },
      },
    },
  },
});

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
